import { type Dispatch, type SetStateAction, memo } from 'react'

import { Checkbox } from '@/components/ui/checkbox'
import type { ListUser } from '@/modules/chatting/types'
import { unescapeHtmlText } from '@/modules/chatting/ui/chat-window/fan-info/utils.ts'
import { CreatorAvatar } from '@/modules/creators/ui/CreatorAvatar'

import { ScrollingUserLists } from '../../components/ScrollingUserLists'

interface Props {
  user: ListUser
  isSelected: boolean
  onSelectedUsersChange: Dispatch<SetStateAction<ListUser[]>>
}

export const UserCard = memo(
  ({ user, isSelected, onSelectedUsersChange }: Props) => {
    return (
      <div className="h-full space-y-3 rounded-lg bg-secondary-50 p-3 dark:bg-secondary-600">
        <div className="flex max-w-full items-start justify-between gap-3 overflow-hidden">
          <div className="flex gap-3 overflow-hidden">
            <CreatorAvatar
              name={user.displayName || user.name}
              avatarSrc={
                user.avatarThumbs?.c50 ?? user.avatarThumbs?.c144 ?? user.avatar
              }
              size={40}
              className="shrink-0"
            />
            <div className="space-y-1 overflow-hidden">
              <p className="overflow-hidden text-ellipsis whitespace-nowrap text-sm font-medium leading-[22px]">
                {unescapeHtmlText(user.displayName || user.name)}
              </p>
              <p className="overflow-hidden text-ellipsis whitespace-nowrap text-xs text-secondary-300">
                @{user.username}
              </p>
            </div>
          </div>
          <Checkbox
            checked={isSelected}
            onCheckedChange={(checked) => {
              onSelectedUsersChange((prev) =>
                checked
                  ? [...prev, user]
                  : prev.filter((u) => u.id !== user.id),
              )
            }}
          />
        </div>
        <ScrollingUserLists user={user} />
      </div>
    )
  },
)

UserCard.displayName = 'UserCard'
